import { useTranslation } from 'react-i18next'

import Text from '../../../../Text'
import { Widget } from '../../../../Widget'
import { useApplicantProfileContext } from '../../RentalPortalApplicantProfile.hooks'

import { QA_NAME_APPLICANT_CREDIT_CHECK } from './ApplicantCreditCheckBlock.constants'
import {
  getHasApplicantCreditCheck,
  getIsApplicantCreditCheckPreScreening,
} from './ApplicantCreditCheckBlock.utils'
import { ApplicantCreditCheckContent } from './ApplicantCreditCheckContent'
import { ApplicantCreditCheckLoadError } from './ApplicantCreditCheckLoadError'
import { ApplicantCreditCheckSkeleton } from './ApplicantCreditCheckSkeleton'

import * as styles from './ApplicantCreditCheckBlock.module.css'

function ApplicantCreditCheckBlock() {
  const { t } = useTranslation()

  const { applicantData, handleEntityReload, isInitiated, isPreview } =
    useApplicantProfileContext()

  function handleClickRetry() {
    handleEntityReload()
  }

  return (
    <Widget
      contentContainerProps={{ Skeleton: ApplicantCreditCheckSkeleton }}
      headerProps={{ contentProps: { actionsProps: { EditButton: null } } }}
      isSkeleton={!isInitiated || !applicantData}
      qaName={QA_NAME_APPLICANT_CREDIT_CHECK}
      title={t('RentalPortal.ApplicantCreditCheckTitleKey')}
    >
      {getHasApplicantCreditCheck(applicantData) ? (
        <div className={styles.body}>
          {getIsApplicantCreditCheckPreScreening(applicantData) ? (
            <Text isSecondary className={styles.line}>
              {t('RentalPortal.ApplicantCreditCheckPoolHintKey')}
            </Text>
          ) : (
            <ApplicantCreditCheckContent
              applicantData={applicantData}
              isPreview={isPreview}
            />
          )}
        </div>
      ) : (
        <ApplicantCreditCheckLoadError onRetry={handleClickRetry} />
      )}
    </Widget>
  )
}

export default ApplicantCreditCheckBlock
